import './range-bar.css';

import { Text } from '@kerfjs/ui/text';
import { type SafeHtml } from 'kerfjs';

import { formatCurrencyText } from '../lib/currency-format.js';

export function RangeBar({
  low,
  high,
  best,
  base,
}: {
  low: number | null;
  high: number | null;
  best: number | null;
  base: string;
}): SafeHtml {
  if (low === null || high === null)
    return (
      <Text variant="span" tone="quiet" size="compact">
        no range
      </Text>
    );
  const scaleMax = Math.max(low, high, best ?? low) * 1.12 || 1;
  const pct = (value: number): number => Math.max(0, Math.min(100, (value / scaleMax) * 100));
  const lowP = pct(low);
  const highP = pct(high);
  const mid = (low + high) / 2;
  return (
    <div
      class="range-bar"
      title={`Benchmark landed ${formatCurrencyText(low, base)}–${formatCurrencyText(high, base)}${best !== null ? `, best quote ${formatCurrencyText(best, base)}` : ''}`}
    >
      <div class="rb-track" />
      <div class="rb-band" style={`left:${String(lowP)}%;width:${String(Math.max(1, highP - lowP))}%`} />
      <div class="rb-mid" style={`left:${String(pct(mid))}%`} />
      {best !== null ? (
        <div
          class="rb-quote"
          data-position={best > mid ? 'over' : 'under'}
          style={`left:${String(pct(best))}%`}
          title={`Best quote ${formatCurrencyText(best, base)}`}
        />
      ) : null}
    </div>
  );
}
